import { utils } from 'kb-shared';
const { setConsent, setConsentSearch, getConsent } = utils;

export const checkAndSetConsent = () => {
  const localConsent = getConsent();
  if (localConsent) return localConsent;

  const search = new URLSearchParams(window.location.search);
  const consent = search.get('consent');
  if (consent) {
    setConsent(consent);
    setConsentSearch(window.location.search);
    return consent;
  }
  return false;
};

export const filterConsentsWithLinkUrl = <T extends { linkUrl?: string | null }>(
  consents: T[] = []
): Array<T & { linkUrl: string }> =>
  consents.filter((consent): consent is T & { linkUrl: string } => Boolean(consent.linkUrl));

export const getConsentsWithoutLinkUrl = <T extends { linkUrl?: string | null }>(
  consents: T[] = []
) => consents.filter(consent => !consent.linkUrl);
